module.exports = __webpack_public_path__ + "img/Clientcontacten.7c45c940.png";